/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { render } from '../lib';
import { VmDefaultUi, VmCaptionControl, VmControl, VmIcon, VmTooltip, VmCaptions, VmClickToPlay, VmControlGroup, VmControlSpacer, VmControls, VmCurrentTime, VmTime, VmDblClickFullscreen, VmDefaultControls, VmEndTime, VmFullscreenControl, VmLiveIndicator, VmMuteControl, VmPipControl, VmPlaybackControl, VmScrim, VmScrubberControl, VmSlider, VmSettingsControl, VmTimeProgress, VmVolumeControl, VmDefaultSettings, VmMenu, VmMenuItem, VmMenuRadio, VmMenuRadioGroup, VmSettings, VmSubmenu, VmLoadingScreen, VmPoster, VmSpinner, VmUi } from '@vime/core';
import { define } from '../lib';
define('vm-default-ui', VmDefaultUi);
define('vm-caption-control', VmCaptionControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
define('vm-captions', VmCaptions);
define('vm-click-to-play', VmClickToPlay);
define('vm-control-group', VmControlGroup);
define('vm-control-spacer', VmControlSpacer);
define('vm-controls', VmControls);
define('vm-current-time', VmCurrentTime);
define('vm-time', VmTime);
define('vm-dbl-click-fullscreen', VmDblClickFullscreen);
define('vm-default-controls', VmDefaultControls);
define('vm-end-time', VmEndTime);
define('vm-fullscreen-control', VmFullscreenControl);
define('vm-live-indicator', VmLiveIndicator);
define('vm-mute-control', VmMuteControl);
define('vm-pip-control', VmPipControl);
define('vm-playback-control', VmPlaybackControl);
define('vm-scrim', VmScrim);
define('vm-scrubber-control', VmScrubberControl);
define('vm-slider', VmSlider);
define('vm-settings-control', VmSettingsControl);
define('vm-time-progress', VmTimeProgress);
define('vm-volume-control', VmVolumeControl);
define('vm-default-settings', VmDefaultSettings);
define('vm-menu', VmMenu);
define('vm-menu-item', VmMenuItem);
define('vm-menu-radio', VmMenuRadio);
define('vm-menu-radio-group', VmMenuRadioGroup);
define('vm-settings', VmSettings);
define('vm-submenu', VmSubmenu);
define('vm-loading-screen', VmLoadingScreen);
define('vm-poster', VmPoster);
define('vm-spinner', VmSpinner);
define('vm-ui', VmUi);
export default Vue.extend({
    props: {
        noClickToPlay: {},
        noDblClickFullscreen: {},
        noCaptions: {},
        noPoster: {},
        noSpinner: {},
        noControls: {},
        noSettings: {},
        noLoadingScreen: {},
    },
    methods: {},
    render: render('vm-default-ui', []),
});
//# sourceMappingURL=DefaultUi.js.map